<template>
        <div class="technologies">
        <div class="row">
          <div data-aos="zoom-in-right">
            <div class="tech-card">
              <svg class="browser" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M473.6,0H38.4A38.4,38.4,0,0,0,0,38.4V473.6A38.4,38.4,0,0,0,38.4,512H473.6A38.4,38.4,0,0,0,512,473.6V38.4A38.4,38.4,0,0,0,473.6,0Zm21.3,473.6a21.3,21.3,0,0,1-21.3,21.3H38.4a21.3,21.3,0,0,1-21.3-21.3V38.4A21.3,21.3,0,0,1,38.4,17.1H473.6a21.3,21.3,0,0,1,21.3,21.3Z"
                />
                <path
                  d="M76.8,34.1H42.7a8.7,8.7,0,0,0-8.6,8.6V76.8a8.6,8.6,0,0,0,8.6,8.5H76.8a8.5,8.5,0,0,0,8.5-8.5V42.7A8.6,8.6,0,0,0,76.8,34.1ZM68.3,68.3H51.2V51.2H68.3Z"
                />
                <path
                  d="M145.1,34.1H110.9a8.6,8.6,0,0,0-8.5,8.6V76.8a8.5,8.5,0,0,0,8.5,8.5h34.2a8.5,8.5,0,0,0,8.5-8.5V42.7A8.6,8.6,0,0,0,145.1,34.1Zm-8.6,34.2h-17V51.2h17Z"
                />
                <path
                  d="M213.3,34.1H179.2a8.6,8.6,0,0,0-8.5,8.6V76.8a8.5,8.5,0,0,0,8.5,8.5h34.1a8.6,8.6,0,0,0,8.6-8.5V42.7A8.7,8.7,0,0,0,213.3,34.1Zm-8.5,34.2H187.7V51.2h17.1Z"
                />
                <path
                  d="M473.6,0H38.4A38.4,38.4,0,0,0,0,38.4v72.5a8.6,8.6,0,0,0,8.5,8.6h495a8.6,8.6,0,0,0,8.5-8.6V38.4A38.4,38.4,0,0,0,473.6,0Zm21.3,102.4H17.1v-64A21.3,21.3,0,0,1,38.4,17.1H473.6a21.3,21.3,0,0,1,21.3,21.3Z"
                />
                <path
                  d="M119.5,145.1H51.2a8.5,8.5,0,0,0-8.5,8.5v68.3a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V153.6A8.5,8.5,0,0,0,119.5,145.1Zm-8.6,68.2H59.7V162.1h51.2Z"
                />
                <path
                  d="M349.9,145.1H281.6a8.5,8.5,0,0,0-8.5,8.5V273.1a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V153.6A8.5,8.5,0,0,0,349.9,145.1Zm-8.6,119.4H290.1V162.1h51.2Z"
                />
                <path
                  d="M349.9,298.7H281.6a8.5,8.5,0,0,0-8.5,8.5v51.2a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V307.2A8.5,8.5,0,0,0,349.9,298.7Zm-8.6,51.2H290.1V315.7h51.2Z"
                />
                <path
                  d="M230.4,145.1H162.1a8.5,8.5,0,0,0-8.5,8.5v85.3a8.6,8.6,0,0,0,8.5,8.6h68.3a8.6,8.6,0,0,0,8.5-8.6V153.6A8.5,8.5,0,0,0,230.4,145.1Zm-8.5,85.3H170.7V162.1h51.2Z"
                />
                <path
                  d="M119.5,384H51.2a8.5,8.5,0,0,0-8.5,8.5v68.3a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V392.5A8.5,8.5,0,0,0,119.5,384Zm-8.6,68.3H59.7V401.1h51.2Z"
                />
                <path
                  d="M119.5,247.5H51.2a8.5,8.5,0,0,0-8.5,8.5V358.4a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V256A8.5,8.5,0,0,0,119.5,247.5Zm-8.6,102.4H59.7V264.5h51.2Z"
                />
                <path
                  d="M230.4,264.5H162.1a8.6,8.6,0,0,0-8.5,8.6V460.8a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V273.1A8.6,8.6,0,0,0,230.4,264.5Zm-8.5,187.8H170.7V281.6h51.2Z"
                />
                <path
                  d="M460.8,145.1H392.5a8.5,8.5,0,0,0-8.5,8.5V290.1a8.6,8.6,0,0,0,8.5,8.6h68.3a8.6,8.6,0,0,0,8.5-8.6V153.6A8.5,8.5,0,0,0,460.8,145.1Zm-8.5,136.5H401.1V162.1h51.2Z"
                />
                <path
                  d="M460.8,315.7H392.5a8.6,8.6,0,0,0-8.5,8.6V460.8a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V324.3A8.6,8.6,0,0,0,460.8,315.7Zm-8.5,136.6H401.1V332.8h51.2Z"
                />
                <path
                  d="M349.9,384H281.6a8.5,8.5,0,0,0-8.5,8.5v68.3a8.5,8.5,0,0,0,8.5,8.5h68.3a8.5,8.5,0,0,0,8.5-8.5V392.5A8.5,8.5,0,0,0,349.9,384Zm-8.6,68.3H290.1V401.1h51.2Z"
                />
              </svg>
              <span>FRONT END</span>
              <ul>
                <li>HTML 5</li>
                <li>CSS3 | SASS</li>
                <li>Vue.js</li>
                <li>React | Redux</li>
              </ul>
            </div>
          </div>

          <div data-aos="zoom-in">
            <div class="tech-card">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 480">
                <path
                  d="M145.2,151.1c-11.2-2-21.5-4.4-30.8-7a8,8,0,1,0-4.5,15.4h.1c9.8,2.8,20.7,5.2,32.4,7.3l1.4.2a8.1,8.1,0,0,0,8-8.1A8,8,0,0,0,145.2,151.1Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M176.5,155.7a8,8,0,1,0-2.3,15.8h.5A689.9,689.9,0,0,0,256,176a708.5,708.5,0,0,0,81.1-4.4,8.1,8.1,0,0,0,7.3-8.7,8,8,0,0,0-8.6-7.3h-.5A699.8,699.8,0,0,1,256,160,703.4,703.4,0,0,1,176.5,155.7Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M176.5,283.7a8,8,0,1,0-2.3,15.8h.5A689.9,689.9,0,0,0,256,304a708.5,708.5,0,0,0,81.1-4.4,8.1,8.1,0,0,0,7.3-8.7,8,8,0,0,0-8.6-7.3h-.5A699.8,699.8,0,0,1,256,288,703.4,703.4,0,0,1,176.5,283.7Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M335.3,411.7A699.8,699.8,0,0,1,256,416a703.4,703.4,0,0,1-79.5-4.3,8,8,0,1,0-2.3,15.8h.5A689.9,689.9,0,0,0,256,432a708.5,708.5,0,0,0,81.1-4.4,8.1,8.1,0,0,0,7.3-8.7,8,8,0,0,0-8.6-7.3Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M145.2,279.1c-11.2-2-21.5-4.4-30.8-7a8,8,0,1,0-4.5,15.4h.1c9.8,2.8,20.7,5.2,32.4,7.3l1.4.2a8.1,8.1,0,0,0,8-8.1A8,8,0,0,0,145.2,279.1Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M145.2,407.1c-11.2-2-21.5-4.4-30.8-7a8,8,0,1,0-4.5,15.4h.1c9.8,2.8,20.7,5.2,32.4,7.3l1.4.2a8.1,8.1,0,0,0,8-8.1A8,8,0,0,0,145.2,407.1Z"
                  transform="translate(-56 -16)"
                />
                <path
                  d="M393.1,25.5A873.6,873.6,0,0,0,256,16a873.6,873.6,0,0,0-137.1,9.5C63.2,34.8,56,46.7,56,56V440c0,36.8,100.6,56,200,56s200-19.2,200-56V56C456,46.7,448.8,34.8,393.1,25.5ZM440,312c0,16.3-71.7,40-184,40S72,328.3,72,312V214.5C108.2,236.2,197.6,240,256,240s147.8-3.8,184-25.5Zm0-120c0,13.3-57.1,32-184,32S72,205.3,72,192V86.5C108.2,108.2,197.6,112,256,112s147.8-3.8,184-25.5ZM72,56.6C77.9,48.1,138.6,32,256,32S434.1,48.1,440,56.6V64c0,13.3-57.1,32-184,32S72,77.3,72,64ZM256,480c-112.3,0-184-23.7-184-40V335.4C104.2,356.9,180.4,368,256,368s151.8-11.1,184-32.6V440C440,456.3,368.3,480,256,480Z"
                  transform="translate(-56 -16)"
                />
              </svg>
              <span>DATABASE</span>
              <ul>
                <li>PostgreSQL</li>
                <li>mySQL</li>
                <li>MongoDB</li>
                <li>Cassandra</li>
              </ul>
            </div>
          </div>
          <div data-aos="zoom-in">
            <div class="tech-card">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480">
                <path
                  d="M400,344a96,96,0,1,0-33.1-186.1A48,48,0,0,0,320,120h-.1A108,108,0,0,0,104,124a116.9,116.9,0,0,0,.8,13.2A104,104,0,0,0,120,344h64v40H144v16h48a8,8,0,0,0,8-8V344h16v16h16V344h16V448H232v16h24a8,8,0,0,0,8-8V344h16v32h16V344h16v80a8,8,0,0,0,8,8h40V416H328V344h16v48a8,8,0,0,0,8,8h48V384H360V344ZM32,240a88.1,88.1,0,0,1,82.6-87.7,8.2,8.2,0,0,0,5.8-3.1,8,8,0,0,0,1.5-6.5A89.9,89.9,0,0,1,120,124a92,92,0,0,1,184,0c0,.9-.1,1.8-.1,2.6v1.9a7.7,7.7,0,0,0,2.8,6.5,7.9,7.9,0,0,0,6.8,1.7A32.1,32.1,0,0,1,352,167.8c0,.3-.2,1.4-.2,1.6a8,8,0,0,0,3.7,7.1,8.1,8.1,0,0,0,8,.4A78.7,78.7,0,0,1,400,168a80,80,0,0,1,0,160H120A88.1,88.1,0,0,1,32,240Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M234.7,59.9A67.3,67.3,0,0,0,212,56V72a50.8,50.8,0,0,1,17.3,3Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M194.7,75l-5.4-15.1A68.2,68.2,0,0,0,144,124h16A52,52,0,0,1,194.7,75Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M290.3,206.5l-14.2-5.9a74.3,74.3,0,0,0-3.4-8.2l5.9-14.2a8.2,8.2,0,0,0-1-8,90.9,90.9,0,0,0-15.8-15.8,8.2,8.2,0,0,0-8-1l-14.2,5.9a58.5,58.5,0,0,0-8.2-3.3l-5.9-14.3a7.8,7.8,0,0,0-6.3-4.9,75.8,75.8,0,0,0-22.3,0,7.8,7.8,0,0,0-6.4,4.9L184.6,156a63.8,63.8,0,0,0-8.2,3.3l-14.2-5.9a8.2,8.2,0,0,0-8,1,90.9,90.9,0,0,0-15.8,15.8,8.2,8.2,0,0,0-1,8l5.9,14.2a82.6,82.6,0,0,0-3.3,8.2l-14.3,5.9a8,8,0,0,0-4.9,6.4,77.4,77.4,0,0,0,0,22.2,7.8,7.8,0,0,0,4.9,6.4l14.3,5.9a63.8,63.8,0,0,0,3.3,8.2l-5.9,14.2a8.2,8.2,0,0,0,1,8,90.9,90.9,0,0,0,15.8,15.8,8.2,8.2,0,0,0,8,1l14.2-5.9a63.8,63.8,0,0,0,8.2,3.3l5.9,14.3a7.8,7.8,0,0,0,6.4,4.9,77.4,77.4,0,0,0,22.2,0,7.8,7.8,0,0,0,6.4-4.9l5.9-14.3a58.5,58.5,0,0,0,8.2-3.3l14.2,5.9a8.2,8.2,0,0,0,8-1,90.9,90.9,0,0,0,15.8-15.8,8.2,8.2,0,0,0,1-8l-5.9-14.2a63.8,63.8,0,0,0,3.3-8.2l14.3-5.9a7.8,7.8,0,0,0,4.9-6.4,77.4,77.4,0,0,0,0-22.2,7.8,7.8,0,0,0-4.9-6.4Zm-10.5,22.1L266.5,234a8.3,8.3,0,0,0-4.7,5.2,53.8,53.8,0,0,1-4.9,12.1,7.8,7.8,0,0,0-.4,7l5.5,13.2a66.5,66.5,0,0,1-6.5,6.5l-13.2-5.5a7.8,7.8,0,0,0-7,.4,53.8,53.8,0,0,1-12.1,4.9,8.1,8.1,0,0,0-5.2,4.7l-5.5,13.3a46.1,46.1,0,0,1-9.1,0L198,282.5a8.3,8.3,0,0,0-5.2-4.7,53.8,53.8,0,0,1-12.1-4.9,7.9,7.9,0,0,0-7-.4L160.5,278a66.5,66.5,0,0,1-6.5-6.5l5.5-13.2a7.8,7.8,0,0,0-.4-7,59.2,59.2,0,0,1-5-12.1,7.9,7.9,0,0,0-4.6-5.2l-13.3-5.4c-.1-1.6-.2-3.1-.2-4.6s.1-3,.2-4.6l13.3-5.4a8.3,8.3,0,0,0,4.7-5.2,53.8,53.8,0,0,1,4.9-12.1,7.8,7.8,0,0,0,.4-7L154,176.5a66.5,66.5,0,0,1,6.5-6.5l13.2,5.5a7.8,7.8,0,0,0,7-.4,53.8,53.8,0,0,1,12.1-4.9,8.3,8.3,0,0,0,5.2-4.7l5.4-13.3a47.1,47.1,0,0,1,9.2,0l5.4,13.3a8.3,8.3,0,0,0,5.2,4.7,53.8,53.8,0,0,1,12.1,4.9,7.8,7.8,0,0,0,7,.4l13.2-5.5a66.5,66.5,0,0,1,6.5,6.5l-5.5,13.2a7.8,7.8,0,0,0,.4,7,53.8,53.8,0,0,1,4.9,12.1,8.3,8.3,0,0,0,4.7,5.2l13.3,5.4c.1,1.6.2,3.1.2,4.6s-.1,3-.2,4.6Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M389.8,290.4l7.8,4.5,8-13.8-7.8-4.5a35,35,0,0,0,1.4-4.6H408V256h-8.8a35,35,0,0,0-1.4-4.6l7.8-4.5-8-13.8-7.8,4.5c-1.1-1.2-2.2-2.3-3.4-3.4l4.5-7.8-13.8-8-4.5,7.8a35,35,0,0,0-4.6-1.4V216H352v8.8a35,35,0,0,0-4.6,1.4l-4.5-7.8-13.8,8,4.5,7.8c-1.2,1.1-2.3,2.2-3.4,3.4l-7.8-4.5-8,13.8,7.8,4.5a35,35,0,0,0-1.4,4.6H312v16h8.8a35,35,0,0,0,1.4,4.6l-7.8,4.5,8,13.8,7.8-4.5c1.1,1.2,2.2,2.3,3.4,3.4l-4.5,7.8,13.8,8,4.5-7.8a35,35,0,0,0,4.6,1.4V312h16v-8.8a35,35,0,0,0,4.6-1.4l4.5,7.8,13.8-8-4.5-7.8C387.6,292.7,388.7,291.6,389.8,290.4ZM360,288a24,24,0,1,1,24-24A24.1,24.1,0,0,1,360,288Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M208,184a40,40,0,1,0,40,40A40,40,0,0,0,208,184Zm0,64a24,24,0,1,1,24-24A24.1,24.1,0,0,1,208,248Z"
                  transform="translate(-16 -16)"
                />
                <path d="M104,384h24v16H104Z" transform="translate(-16 -16)" />
                <path
                  d="M232,424V376H216v40H184v16h40A8,8,0,0,0,232,424Z"
                  transform="translate(-16 -16)"
                />
                <path d="M144,416h24v16H144Z" transform="translate(-16 -16)" />
                <path d="M104,416h24v16H104Z" transform="translate(-16 -16)" />
                <path d="M152,448h64v16H152Z" transform="translate(-16 -16)" />
                <path d="M120,480h16v16H120Z" transform="translate(-16 -16)" />
                <path d="M152,480h16v16H152Z" transform="translate(-16 -16)" />
                <path d="M184,480h16v16H184Z" transform="translate(-16 -16)" />
                <path d="M280,480H216v16h72a8,8,0,0,0,8-8V448H280Z" transform="translate(-16 -16)" />
                <path d="M280,392h16v40H280Z" transform="translate(-16 -16)" />
                <path
                  d="M62.5,400H88V384H62.5a24,24,0,1,0,0,16ZM32,392a8,8,0,1,1,8,8A8,8,0,0,1,32,392Z"
                  transform="translate(-16 -16)"
                />
                <path d="M376,416h24v16H376Z" transform="translate(-16 -16)" />
                <path d="M416,416h24v16H416Z" transform="translate(-16 -16)" />
                <path
                  d="M472,368a23.9,23.9,0,0,0-22.5,16H416v16h33.5A23.9,23.9,0,1,0,472,368Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,472,400Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M64,432a24,24,0,1,0,22.5,32H136V448H86.5A23.9,23.9,0,0,0,64,432Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,64,464Z"
                  transform="translate(-16 -16)"
                />
              </svg>
              <span>DEPLOYMENT</span>
              <ul>
                <li>Firebase</li>
                <li>AWS</li>
                <li>Heroku</li>
                <li>Git</li>
              </ul>
            </div>
          </div>

          <div data-aos="zoom-in-left">
            <div class="tech-card">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 480">
                <path
                  d="M464,16a32,32,0,0,0-32,32V194.9a31.5,31.5,0,0,0-34.9,15l-5.1,8.8V152a8,8,0,0,0-8-8H360V128h24a8,8,0,0,0,8-8V24a8,8,0,0,0-8-8H128a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h24v16H128a8,8,0,0,0-8,8v66.7l-5.1-8.8a31.5,31.5,0,0,0-34.9-15V48a32,32,0,0,0-64,0V316.2a40.2,40.2,0,0,0,9.6,26l24.6,28.7A24.1,24.1,0,0,1,56,386.5V432H48a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8H176a8,8,0,0,0,8-8V440a8,8,0,0,0-8-8h-8V312.6a39.3,39.3,0,0,0-5.4-20L141.5,256h229l-21.1,36.6a38.7,38.7,0,0,0-5.4,20V432h-8a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8H464a8,8,0,0,0,8-8V440a8,8,0,0,0-8-8h-8V386.5a24.1,24.1,0,0,1,5.8-15.6l24.6-28.7a40.2,40.2,0,0,0,9.6-26V48A32,32,0,0,0,464,16ZM168,480H56V448H168ZM152,312.6V432H72V386.5a40,40,0,0,0-9.6-26L37.8,331.8A24.3,24.3,0,0,1,32,316.2V48a16,16,0,0,1,32,0V204.1a31.6,31.6,0,0,0-4.5,37.8l52,90.1a8,8,0,0,0,13.9-8l-52-90.1a16,16,0,0,1,27.7-16l47.7,82.7A24,24,0,0,1,152,312.6ZM136,32H376v80H136Zm32,96H344v16H168Zm-32,32H376v80H136ZM456,480H344V448H456Zm24-163.8a24.3,24.3,0,0,1-5.8,15.6l-24.6,28.7a40,40,0,0,0-9.6,26V432H360V312.6a24,24,0,0,1,3.2-12l47.7-82.7a16,16,0,0,1,27.8,15.8c0,.1,0,.2-.1.2l-52,90.1a8,8,0,0,0,2.9,10.9,7.9,7.9,0,0,0,10.9-2.8.1.1,0,0,0,.1-.1l52-90.1a31.6,31.6,0,0,0-4.5-37.8V48a16,16,0,0,1,32,0Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M176,48a24,24,0,1,0,24,24A23.9,23.9,0,0,0,176,48Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,176,80Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M240,48a24,24,0,1,0,24,24A23.9,23.9,0,0,0,240,48Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,240,80Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M304,48H288a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M304,80H288a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M352,48H336a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M352,80H336a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M176,176a24,24,0,1,0,24,24A23.9,23.9,0,0,0,176,176Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,176,208Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M240,176a24,24,0,1,0,24,24A23.9,23.9,0,0,0,240,176Zm0,32a8,8,0,1,1,8-8A8,8,0,0,1,240,208Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M304,176H288a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M304,208H288a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M352,176H336a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M352,208H336a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M152,456H136a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z"
                  transform="translate(-16 -16)"
                />
                <path
                  d="M360,472h16a8,8,0,0,0,0-16H360a8,8,0,0,0,0,16Z"
                  transform="translate(-16 -16)"
                />
              </svg>
              <span>SERVER</span>
              <ul>
                <li>NodeJS</li>
                <li>Express</li>
                <li>Python</li>
                <li>Koa</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
export default {

}
</script>

<style>

</style>